<ng-container *ngIf="editItemMode && control; else view">
  <div class="field-container flex-1">
    <mat-form-field class="flex-1">
      <!-- <mat-label>{{ property.displayName }}</mat-label> -->

      <ng-container [ngSwitch]="property.type">
        <ng-container *ngSwitchCase="'INT'">
          <input
            style="flex: 0 0 auto"
            type="number"
            matInput
            [formControl]="control"
            [placeholder]="property.displayName || property.name"
            class="property-value"
          />
          <span *ngIf="property.displayOptions?.unit" class="property-units">{{
            property.displayOptions.unit
          }}</span>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <textarea
            cdkTextareaAutosize
            matInput
            [formControl]="control"
            [placeholder]="property.displayName || property.name"
            class="property-value"
          ></textarea>
        </ng-container>

        <ng-container *ngSwitchCase="'REFERENCE'">
          <mat-select [formControl]="control">
            <mat-select-trigger class="d-flex jc-center ai-center" style="padding-left: 18px">
              <ng-container *ngTemplateOutlet="display; context: { value: control.value }">
              </ng-container>
            </mat-select-trigger>

            <ng-container *ngFor="let option of referenceOptions; trackBy: trackObject">
              <mat-option [value]="option">
                <ng-container *ngTemplateOutlet="display; context: { value: option }">
                </ng-container>
              </mat-option>
            </ng-container>
          </mat-select>
        </ng-container>
      </ng-container>
    </mat-form-field>
  </div>
</ng-container>

<ng-template #view>
  <ng-container *ngTemplateOutlet="display; context: { value }"></ng-container>
</ng-template>

<ng-template #display let-value="value">
  <ng-container *ngTemplateOutlet="isReference ? reference : notReference; context: { value }">
  </ng-container>
  <!-- <ng-container *ngTemplateOutlet="property.displayOptions?.isChippable ? chip : basicValue; context: { value }">
  </ng-container> -->
</ng-template>
<ng-template #notReference let-value="value">
  <ng-container
    *ngTemplateOutlet="
      isChippable
        ? chip
        : property.type === 'DATE'
          ? dateValue
          : isHtmlType()
            ? htmlValue
          : config?.raw
            ? rawValue
            : basicValue;
      context: { value }
    "
  >
  </ng-container>
</ng-template>

<ng-template #reference let-value="value">
  <ng-container *ngIf="isReference && property.referenceOptions?.type == 'one_to_one' && hasValue(value)">
    <ng-container *ngTemplateOutlet="notReference; context: { value: value.name }"> </ng-container>
  </ng-container>
  <ng-container *ngIf="isReference && property.referenceOptions?.type == 'one_to_many' && hasValue(value)">
    <ng-container *ngFor="let item of value">
      <ng-container *ngTemplateOutlet="notReference; context: { value: item.name }"> </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #chip let-value="value">
  <div
    class="chip d-flex jc-center ai-center"
    [style]="getChipStyles(value, property)"
    style="flex: 0 0 auto"
  >
    <span>{{ value }}</span>
  </div>
</ng-template>

<ng-template #basicValue let-value="value">
  <div class="d-flex fd-row" *ngIf="hasValue(value)">
    <a
      *ngIf="isHttpLink(value); else textValue"
      class="property-value"
      [href]="value"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ value }}
    </a>
    <ng-template #textValue>
      <p class="property-value">{{ value }}</p>
    </ng-template>
    <span *ngIf="property.displayOptions?.unit" class="property-units">{{
      property.displayOptions.unit
    }}</span>
  </div>
</ng-template>

<ng-template #dateValue let-value="value">
  <div class="d-flex fd-row" *ngIf="hasValue(value)">
    <p class="property-value">{{ value | date: 'd MMM yyyy' }}</p>
  </div>
</ng-template>

<ng-template #htmlValue>
  <div class="property-value" *ngIf="sanitizedHtmlValue" [innerHTML]="sanitizedHtmlValue"></div>
</ng-template>

<ng-template #rawValue let-value="value">
  <!-- <mat-icon class="property-value">link</mat-icon> -->
  <div class="property-value" [innerHTML]="value"></div>
</ng-template>
